import log from 'salvo-lite/log'

class Validate {
    constructor (theme, elem) {
        this.theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.dataset.validate)
        this._elemsToCheck = this._data.elems
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('submit', e => {
            for (let i = 0; i < this._elemsToCheck.length; i++) {
                const elem = this._elem.querySelector(this._elemsToCheck[i])
                if (elem.value.length <= 0) {
                    e.preventDefault()
                }
            }
        })
    }
}

export default Validate



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Validate.js